<ng-container *ngIf="loanProduct">
  {{ getText() }}
</ng-container>